import { METODO_PAGAMENTO_CARTAO, METODO_PAGAMENTO_PIX } from '../../constants'

export const BRINDES_PLANO_ANUAL = 'Apenas para plano anual: ganhe um brinde exclusivo'

export const TITULO_TELA_PLANO = 'Escolha seu plano'

export const VER_MAIS_ENDERECO = 'Ver outros endereços cadastrados'

export const TITULO_TELA_ENTREGA = 'Escolha seu endereço'

export const TITULO_ENTREGA_TELA_CONCLUSAO = 'Endereço'

export const DESCRICAO_TELA_ENTREGA = 'Você pode manter o endereço de entrega existente ou adicionar um novo.'

export const TITULO_ENDERECOS_CADASTRADOS = 'Usar endereço cadastrado'

export const TITULO_CADASTRAR_NOVO_ENDERECO = 'Adicionar novo endereço'

export const TITULO_MODAL_ESCOLHER_ENDERECO = 'Deseja usar outro endereço?'

export const DESCRICAO_MODAL_ESCOLHER_ENDERECO = 'Você possui outros endereços cadastrados anterioremente. Selecione qual deseja usar para concluir sua compra.'

export const ID_CADASTRO_NOVO_ENDERECO = 'novo-endereco'

export const TITULO_TELA_PAGAMENTO = 'Escolha a forma de pagamento'

export const TITULO_PAGAMENTO_TELA_RESUMO = 'Pagamento'

export const TITULO_ESCOLHA_BRINDE = 'Selecione o brinde'

export const DESCRICAO_ESCOLHA_BRINDE = 'Escolha abaixo qual brinde você deseja receber:'

export const ID_RADIO_GROUP_PAGAMENTO_CARTAO = 'escolha-cartao'

export const TITULO_ESCOLHA_CARTAO_CREDITO_EXISTENTE = 'Usar cartão cadastrado'

export const ADICIONAR_NOVO_CARTAO = 'Adicionar novo cartão de crédito'

export const ID_ADICIONAR_NOVO_CARTAO = 'novo-cartao'

export const DESCRICAO_ESCOLHA_CARTAO_CREDITO = 'Faça o pagamento com seu cartão cadastrado ou adicione um novo.'

export const DESCRICAO_ESCOLHA_CARTAO_NOVO = 'Adicione um novo cartão de crédito para efetuar o pagamento.'

export const TITULO_TELA_CONCLUSAO = 'Concluir'

export const TITULO_RESUMO_TELA_CONCLUSAO = 'Resumo'

export const ETAPA_PLANO = 'PLANO'

export const ETAPA_ENTREGA = 'ENTREGA'

export const ETAPA_PAGAMENTO = 'PAGAMENTO'

export const ETAPA_BRINDES = 'BRINDES'

export const ETAPA_CONCLUSAO = 'CONCLUSAO'

export const BOTAO_GERAR_PIX = 'Gerar PIX'

export const URL_SELECIONAR_PLANO = 'selecionar-plano'

export const URL_SELECIONAR_ENTREGA = 'selecionar-entrega'

export const URL_SELECIONAR_PAGAMENTO = 'selecionar-pagamento'

export const URL_SELECIONAR_BRINDES = 'selecionar-brindes'

export const URL_CONCLUSAO = 'conclusao'

export const PARCELA_PADRAO_ANUAL = { 'value': '12', 'visulização': '12x' }
export const PARCELA_PADRAO_TRIMESTRAL = { 'value': '3', 'visulização': '3x' }

export const TIPOS_FLUXO_BRINDES = {
  'assinatura': 'CRIACAO_ASSINATURA',
  'reativação de plano': 'REATIVACAO_ASSINATURA',
  'renovação de plano': 'RENOVACAO_PLANO',
  'upgrade de plano': 'UPGRADE_PLANO'
}

export const mensagemSucessoFluxoPagamento = fluxo => {
  const opcoes = {
    'CRIACAO_ASSINATURA': {
      [ METODO_PAGAMENTO_PIX.inicial ]: 'A segunda assinatura será realizada assim que você fizer o pagamento do seu pix.',
      [ METODO_PAGAMENTO_CARTAO.inicial ]: 'Segunda assinatura realizada com sucesso!'
    },
    'REATIVACAO_ASSINATURA': {
      [ METODO_PAGAMENTO_PIX.inicial ]: 'A reativação de assinatura será realizada assim que você fizer o pagamento do seu pix.',
      [ METODO_PAGAMENTO_CARTAO.inicial ]: 'Reativação de assinatura realizada com sucesso!'
    },
    'RENOVACAO_PLANO': {
      [ METODO_PAGAMENTO_PIX.inicial ]: 'A renovação de plano será realizada assim que você fizer o pagamento do seu pix.',
      [ METODO_PAGAMENTO_CARTAO.inicial ]: 'Renovação de plano realizado com sucesso!'
    },
    'UPGRADE_PLANO': {
      [ METODO_PAGAMENTO_PIX.inicial ]: 'O Upgrade de plano será realizado assim que você fizer o pagamento do seu pix.',
      [ METODO_PAGAMENTO_CARTAO.inicial ]: 'Upgrade de plano realizado com sucesso!'
    }
  }

  return opcoes[ fluxo ]
}

export const POSSIVEIS_ROTAS_FLUXOS_PAGAMENTO = [ URL_SELECIONAR_PLANO, URL_SELECIONAR_ENTREGA, URL_SELECIONAR_PAGAMENTO, URL_CONCLUSAO ]
